import Badge from 'react-bootstrap/Badge'

import LinkHelper from '@/components/Panels/LinkHelper/LinkHelper'
import { PartnerCountType } from '@/types/page'

import styles from './NavigationPanel.module.scss'
import PartnersTypeahead from './TagsTypeahead/PartnersTypeahead'

type Props = {
  partnercounts: PartnerCountType[]
}

const NavigationPanelPartners = ({ partnercounts }: Props) => {
  if (partnercounts.length === 0) {
    return null
  }

  return (
    <div>
      <div className={styles.navigationTitle}>Partners</div>
      <div className={styles.tags}>
        {partnercounts.slice(0, 6).map(({ count, href, value }) => (
          <LinkHelper block ellipsis href={href || '#'} key={href} scroll={false}>
            <span className={styles.label}>{value}</span>
            <Badge bg='light' className='text-dark'>
              {count >= 1000 ? `${Math.floor(count / 1000)}K` : count}
            </Badge>
          </LinkHelper>
        ))}
      </div>
      <PartnersTypeahead partnercounts={partnercounts} />
    </div>
  )
}

export default NavigationPanelPartners
